import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=63bbc00e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bbc00e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bbc00e')) {
      api.createRecord('63bbc00e', component.options)
    } else {
      api.reload('63bbc00e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=63bbc00e&scoped=true&", function () {
      api.rerender('63bbc00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uL3rAjmWEnP2/JS/comp/SearchFilterTokens.vue"
export default component.exports